var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success btn-sm d-flex align-items-center",on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"mdi mdi-arrow-left"}),_vm._v(" Geri Dön ")])
}
var staticRenderFns = []

export { render, staticRenderFns }